import { FundingProgressIndicator } from '../FundingProgressIndicator/FundingProgressIndicator';
import { FlexiApprovedView } from './FlexiApprovedView/FlexiApprovedView';
import { LoanSummary } from './LoanSummary/LoanSummary';

export const ApprovedView = () => {
    return (
        <div className="flex flex-col bg-structure-100 min-m:flex-row">
            <div className="flex grow basis-0 justify-center min-m:justify-end min-m:px-2xl">
                <div className="max-w-[610px]">
                    <FundingProgressIndicator step={2} />
                    <FlexiApprovedView />
                </div>
            </div>
            <LoanSummary />
        </div>
    );
};
